import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

interface CategoryNavProps {
  active: string;
  onSelect: (slug: string) => void;
}

export default function CategoryNav({ active, onSelect }: CategoryNavProps) {
  return (
    <section className="bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-1 py-3 overflow-x-auto scrollbar-hide flex-wrap">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => onSelect(cat.slug)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                active === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              <span>{cat.name}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}